import { lazy } from 'react';

// Start fonts only when the reader is requested, including legacy /#/ routes.
// Font network failures must not prevent the reader from opening with fallbacks.
export function loadReaderFonts() {
  if (document.querySelector('link[data-reader-fonts]')) {
    return;
  }
  for (const origin of [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://revelationary.org',
    'https://cdn.jsdelivr.net',
  ]) {
    if (!document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
      const hint = document.createElement('link');
      hint.rel = 'preconnect';
      hint.href = origin;
      if (origin === 'https://fonts.gstatic.com') {
        hint.crossOrigin = 'anonymous';
      }
      document.head.appendChild(hint);
    }
  }
  const fonts = document.createElement('link');
  fonts.rel = 'stylesheet';
  fonts.dataset.readerFonts = '';
  fonts.href =
    'https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700&family=Noto+Sans+SC:wght@400;500;700&family=Crimson+Text:wght@400;600&family=Noto+Serif+Hebrew:wght@400;600&family=Lora:ital,wght@0,400;0,600;1,400&family=Noto+Sans:ital,wght@0,400;0,500;0,700&family=Be+Vietnam+Pro:wght@400;500;600&display=swap';
  document.head.appendChild(fonts);
}

// Keep CRA's extensionless code-split import in JavaScript. The legacy project
// uses NodeNext TypeScript resolution, while Webpack resolves the TSX module.
export default lazy(() => {
  loadReaderFonts();
  return import('../App');
});
